const calculateOffset = (page) => {
    return Math.floor(page - 1) * 10;
}

export default calculateOffset;